import React, { FC, useState } from 'react';
import { Swiper } from 'antd-mobile';
import classnames from 'classnames';
import { MTools } from '@/components';
import styles from './index.less';

interface ComProps {
  list: any[];
}

const SubForum: FC<ComProps> = ({
  list = [],
}) => {
  const [currentIndex, setCurrentIndex] = useState(1);

  const handleIndexChange = (_index: number) => {
    setCurrentIndex(_index);
  }

  const handleGoToDetail = (_id: string) => {
    MTools.Url.gotoUrl(`/app/ForumDetail/${_id}`);
  }

  return (
    <div className={styles.subForumWrapper}>
      <Swiper
        trackOffset={16.4}
        slideSize={67.2}
        defaultIndex={1}
        indicator={() => null}
        onIndexChange={handleIndexChange}
      >
        {
          list.map((item: any, _idx: number) => (
            <Swiper.Item key={item.id} onClick={() => handleGoToDetail(item.id)}>
              <div className={classnames(
                styles.itemInner,
                _idx === currentIndex - 1 ? styles.preItem : null,
                _idx === currentIndex + 1 ? styles.nextItem : null
              )}>
                <div className={styles.itemImg}>
                  <img src={item.cover} alt="" />
                </div>
                <div className={styles.itemText}>{item.title}</div>
              </div>
            </Swiper.Item>
          ))
        }
      </Swiper>
    </div>
  );
};

export default SubForum;
